import appLayout from '../layouts/AppLayout.vue'
export default [
  // HOTEL
  {
    path: '/product/hotel',
    name: 'product-hotel-list',
    component: () => import('../views/product/hotel/HotelIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/hotel/create',
    name: 'product-hotel-create',
    component: () => import('../views/product/hotel/HotelCreate.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/hotel/:id',
    name: 'product-hotel-edit',
    component: () => import('../views/product/hotel/HotelEdit.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/hotel/avail/',
    name: 'product-hotel-avail',
    component: () => import('../views/product/hotel/HotelAvail.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/hotel/configuration/',
    name: 'product-hotel-configuration',
    component: () => import('../views/product/hotel/HotelConfiguration.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/transfer',
    name: 'product-transfer-list',
    component: () => import('../views/product/transfer/TransferIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/transfer/create',
    name: 'product-transfer-create',
    component: () => import('../views/product/transfer/TransferCreate.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/transfer/:id',
    name: 'product-transfer-edit',
    component: () => import('../views/product/transfer/TransferEdit.vue'),
    meta: { layout: appLayout }
  },
  // {
  //   path: '/product/transfer/avail/:id',
  //   name: 'product-transfer-avail',
  //   component: () => import('../views/product/transfer/TransferAvail.vue'),
  //   meta: { layout: appLayout }
  // },
  {
    path: '/product/ticket',
    name: 'product-ticket-list',
    component: () => import('../views/product/ticket/TicketIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/ticket/create',
    name: 'product-ticket-create',
    component: () => import('../views/product/ticket/TicketCreate.vue'),
    meta: { layout: appLayout }
  },

  {
    path: '/product/ticket/avail',
    name: 'product-ticket-avail',
    component: () => import('../views/product/ticket/TicketAvail.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/ticket/:id',
    name: 'product-ticket-edit',
    component: () => import('../views/product/ticket/TicketEdit.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/insurance',
    name: 'product-insurance-list',
    component: () => import('../views/product/insurance/InsuranceIndex.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/insurance/create',
    name: 'product-insurance-create',
    component: () => import('../views/product/insurance/InsuranceCreate.vue'),
    meta: { layout: appLayout }
  },
  {
    path: '/product/insurance/:id',
    name: 'product-insurance-edit',
    component: () => import('../views/product/insurance/InsuranceEdit.vue'),
    meta: { layout: appLayout }
  }
]
